import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const ingredientPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  isWholeFood: PropTypes.bool.isRequired,
  isVague: PropTypes.bool.isRequired,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
  node: nodePropType.isRequired,
})

ingredientPropType.defaultProps = {
  synonyms: undefined,
  isExcludedFromSearch: false,
  description: undefined,
}

export default ingredientPropType
